export default "__VITE_ASSET__Dhhs3VTx__"